import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

export const TradingPlans: React.FC = () => {
    return (
        <div className="bv-trading-plans-page page">
            <div className="breadcrumb-area">
                <div className="container h-100">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-lg-5">
                            <div className="breadcrumb-title text-center">
                                <h2>Investment Plans</h2>
                                <ul className="breadcrumb-list">
                                    <li>Home</li>
                                    <li> <FontAwesomeIcon icon={icon({ name: 'angle-double-right', style: 'solid' })} /> </li>
                                    <li>Investment Plans</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-details-area section-padding-100-50 bg-gray-cu">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-details-content mb-50">
                                <div className="prix">
                                    <div className="pricing-wrapper clearfix">
                                        <h1 className="pricing-table-title">Investment Plans</h1>
                                        
                                        <div className="pricing-table">
                                            <h3 className="pricing-title">BASIC</h3>

                                            <div className="price">$1500<sup></sup></div>

                                            <ul className="table-list">
                                                <li>
                                                    <FontAwesomeIcon className="check" icon={icon({ name: 'check', style: 'solid' })} />
                                                    {' '}
                                                    ATS
                                                </li>                    
                                            </ul>

                                            <div className="table-buy">
                                                <p>$1500<sup></sup></p>
                                                <a href="https://caryatid.live/register?plan=1" className="pricing-action">Purchase</a>
                                            </div>
                                        </div>
                                        
                                        <div className="pricing-table">
                                            <h3 className="pricing-title">EMERALD</h3>

                                            <div className="price">$7600<sup></sup></div>

                                            <ul className="table-list">
                                                <li>
                                                    <FontAwesomeIcon className="check" icon={icon({ name: 'check', style: 'solid' })} />
                                                    {' '}
                                                    ATS
                                                </li>                  
                                            </ul>

                                            <div className="table-buy">
                                                <p>$7600<sup></sup></p>
                                                <a href="https://caryatid.live/register?plan=2" className="pricing-action">Purchase</a>
                                            </div>
                                        </div>

                                        <div className="pricing-table">
                                            <h3 className="pricing-title">Diamond</h3>

                                            <div className="price">$21199<sup></sup></div>

                                            <ul className="table-list">
                                                <li>
                                                    <FontAwesomeIcon className="check" icon={icon({ name: 'check', style: 'solid' })} />
                                                    {' '}
                                                    ATS
                                                </li>            
                                            </ul>
                                            
                                            <div className="table-buy">
                                                <p>$21199<sup></sup></p>
                                                <a href="https://caryatid.live/register?plan=3" className="pricing-action">Purchase</a>
                                            </div>
                                        </div>
                                        
                                        <div className="pricing-table">
                                            <h3 className="pricing-title">Platinum</h3>

                                            <div className="price">$50730<sup></sup></div>

                                            <ul className="table-list">
                                                <li>
                                                    <FontAwesomeIcon className="check" icon={icon({ name: 'check', style: 'solid' })} />
                                                    {' '}
                                                    ATS (VIP)
                                                </li>  
                                            </ul>

                                            <div className="table-buy">
                                                <p>$50730<sup></sup></p>
                                                <a href="https://caryatid.live/register?plan=4" className="pricing-action">Purchase</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
    )
}